<template>
    <!---------------------------------

        Table of Content:

        Client:
        1. No proposials yet        
        2. Client: Waiting for proposials
        3. Client: Waiting for raiting
        4. Client: Select winner
        5. Client: Winner and ranking
      
        Worker:
        6. Worker: Application for participation
        7. Worker: In



    ----------------------------------->

    <div class="project-content">

        <!-- 1. No proposials yet -->
        <div style="">
            <div class="row mt-2">
                <div class="col-12">
                    <div class="auction-item auction-loading list-item shadow text-center d-flex justify-content-center align-items-center pt-5 pb-5 pl-4 pr-4">
                        <div>
                            <span class="icon icon-loader"></span>
                            <div class="text mt-4">
                                <h4 class="mb-0">
                                   Все още няма идейни предложения.
                                </h4>
                                Дизайнерите са получили известие за твоя проект и съвсем скоро ще вземат участие.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 2. Client: Waiting for proposials -->
        <div style="">
            <div class="row mt-2">
                <div class="col-12">
                    <div class="alert alert-success alert-sideicon mb-4">
                        <span class="alert-icon icon-team"></span>
                        <strong>Статус:</strong> 6 изпълнители са взели участие за изработка на идеен проект.
                        <br />
                        <strong>Моля, изчакайте, докато всички участници изпратят своите предложения.</strong>
                    </div>
                </div>
            </div>
            <div class="row">         
                <div v-for="n in 6" class="col-xl-4 col-sm-6 mb-4 mt-2">
                    <div v-if="n == 2" class="list-item shadow-lg h-100 list-waiting d-flex 
                        justify-content-center align-items-center">
                        <div class="inner text-green text-center pl-4 pr-4 pt-5 pb-5">
                            <span class="icon icon-loader d-block mb-4"></span>
                            <span class="text">Предложението е в процес на изработка.</span>
                        </div>
                    </div>

                    <div v-else class="list-item shadow-lg h-100">
                        <div class="list-img">
                            <a href="#" class="lp-box-link">
                                <img class="img-responsive" src="/resources/images/def-img.jpg" alt="Proposal Image">
                                <span class="overlay d-flex align-items-center justify-content-center">
                                    <span class="overlay-inner text-center">
                                        <span class="icon icon-chevrons-right"></span>
                                        <span class="text mt-3">Виж повече</span>
                                    </span>
                                </span>                            
                            </a>
                        </div>
                        <div class="list-info pl-4 pr-4 pt-3 pb-3">
                            <h6 class="mb-0">
                                <a href="#">Предложение за дизайн на апартамент</a>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3. Client: Waiting for raiting -->
        <div style="">
            <div class="row mt-2">
                <div class="col-12">
                    <div class="alert alert-primary alert-sideicon mb-4">
                        <span class="alert-icon icon-cup"></span>
                        <strong>Статус:</strong> 6 изпълнители са взели участие за изработка на идеен проект.
                        <br />
                        <strong>Моля, оценете поне три от тях и изберете победител.</strong>
                    </div>
                </div>
            </div>
            <div class="row">         
                <div v-for="n in 6" class="col-xl-4 col-sm-6 mb-4 mt-2">
                    <div class="list-item shadow-lg h-100 d-flex flex-column justify-content-between">
                        <div class="list-content">
                            <div class="list-img">
                                <a href="#" class="lp-box-link">
                                    <img class="img-responsive" src="/resources/images/def-img.jpg" alt="Proposal Image">
                                    <span class="overlay d-flex align-items-center justify-content-center">
                                        <span class="overlay-inner text-center">
                                            <span class="icon icon-chevrons-right"></span>
                                            <span class="text mt-3">Виж повече</span>
                                        </span>
                                    </span>                            
                                </a>
                            </div>
                            <div class="list-info pl-4 pr-4 pt-3 pb-3">
                                <h6 class="mb-0">
                                    <a href="#">Предложение за дизайн на апартамент</a>
                                </h6>
                            </div>
                        </div>
                        <div class="list-bottom pl-4 pr-4 pt-2 pb-3 pt-0 text-orange">  <div>     
                                <span class="icon icon-alert-triangle"></span>
                                Очаква оценка
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 4. Client: Select winner -->
        <div style="">
           <div class="row mt-2">
                <div class="col-12">
                    <div class="alert alert-primary alert-sideicon mb-4">
                        <span class="alert-icon icon-cup"></span>
                        <strong>Статус:</strong> Всички предложения са успешно оценени от теб. Можеш да видиш оценките под заглавията им.
                        <br />
                        <strong>Остава да избереш победител.</strong>
                    </div>
                </div>
            </div>
            <div class="row">         
                <div v-for="n in 6" class="col-xl-4 col-sm-6 mb-4 mt-2">
                    <div class="list-item shadow-lg h-100 d-flex flex-column justify-content-between">
                        <div class="list-content">
                            <div class="list-img">
                                <div class="best-rating" v-if="n == 1">
                                    Най-висока оценка
                                </div>
                                <a href="#" class="lp-box-link">
                                    <img class="img-responsive" src="/resources/images/def-img.jpg" alt="Proposal Image">
                                    <span class="overlay d-flex align-items-center justify-content-center">
                                        <span class="overlay-inner text-center">
                                            <span class="icon icon-chevrons-right"></span>
                                            <span class="text mt-3">Виж повече</span>
                                        </span>
                                    </span>                            
                                </a>
                            </div>
                            <div class="list-info pl-4 pr-4 pt-3 pb-3">
                                <h6 class="mb-0">
                                    <a href="#">Предложение за дизайн на апартамент</a>
                                </h6>
                            </div>
                        </div>
                        <div class="list-bottom pl-4 pr-4 pt-2 pb-3 pt-0 text-orange">
                            <div class="mb-2">
                                Оценка: 4.8
                            </div>
                            <a href="#" class="btn btn-primary btn-block">Избери за победител</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 5. Client: Winner and ranking -->
        <div style="">
            <div class="row mt-2">
                <div class="col-12">
                    <div class="alert alert-primary alert-sideicon mb-4">
                        <span class="alert-icon icon-cup"></span>
                        <strong>Статус:</strong> Етап "Идеен проект" е завършен успешно.
                        <br />
                        <strong>Победителят е избран.</strong>
                    </div>
                </div>
            </div>

            <div class="row">         
                <div v-for="n in 6" class="col-xl-4 col-sm-6 mb-4 mt-2">
                    <div class="list-item shadow-lg h-100 d-flex flex-column justify-content-between">
                        <div class="list-content">
                            <div class="list-img">
                                <a href="#" class="lp-box-link">
                                    <img class="img-responsive" src="/resources/images/def-img.jpg" alt="Proposal Image">
                                    <span v-if="n == 1" class="badge-winner">
                                        <span class="text-winner">
                                            Победител
                                        </span>
                                    </span>
                                    <span class="overlay d-flex align-items-center justify-content-center">
                                        <span class="overlay-inner text-center">
                                            <span class="icon icon-chevrons-right"></span>
                                            <span class="text mt-3">Виж повече</span>
                                        </span>
                                    </span>                            
                                </a>
                                <span v-if="n == 1" class="num-place">1.</span>
                                <span v-if="n == 2" class="num-place">2.</span>
                                <span v-if="n == 3" class="num-place">3.</span>
                            </div>
                            <div class="list-info pl-4 pr-4 pt-3 pb-3">
                                <h6 class="mb-0">
                                    <a href="#">Предложение за дизайн на апартамент</a>
                                </h6>
                            </div>
                        </div>
                        <div class="list-bottom pl-4 pr-4 pt-2 pb-3 pt-0 text-orange">
                            <div class="mb-2">
                                Оценка: 4.8
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>

        <!-- 6. Worker: Application for participation -->
        <div>
            <div class="row mt-2">                 
                <div class="col-lg-5 order-lg-2 mb-4 mb-lg-0">
                    <div class="list-item shadow pl-5 pr-5 pt-4 pb-4 h-100 mb-0 text-center justify-content-center align-items-center d-flex">
                        <div>
                            <span class="icon icon-loader text-green loader-big"></span>
                            <h4 class="mt-4 mb-0">Оставащо време</h4>
                            <div class="time-count mt-0">
                                56:10:00
                            </div>
                        </div>
                    </div>
                </div>
           
                <div class="col-lg-7">
                    <fieldset class="fieldset h-100 mb-0">
                        <h3 class="fieldset-title">Заяви своето участие</h3>
                        <div class="row">
                            <div class="col-12 text-center">
                                <p>
                                    За да участваш с предложение за идеен проект, 
                                    необходимо е да се запишеш за участие, 
                                    натискайки бутона отдолу. Това ти гарантира, че
                                    ще получиш известие при настъпили събития в проекта.
                                </p>
                                <p>
                                    <strong>Записвайки се за участие, ти гарантираш, че ще
                                    предоставиш идеен проект в определения срок. Неспазване
                                    на ангажимента води до редуциране на рейтинга ти.</strong>
                                </p>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center mt-2">
                                <button class="btn btn-primary btn-lg">Участвам</button>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

        },

        data() {
            return {
                isReady : false,
                phases  : [],
                project_phases  : [],

                model : false,
                selectedPhase : false,

                pMdl : {
                    project_id : this.$route.params.id,
                    phase_id   : null,
                    info       : '',
                    start_date : null,
                    end_date   : null
                }
            }
        },

        methods : {

        }

    }
</script>
